import React, { useEffect, useState } from 'react'
import Reports from '../../components/Reports/Reports'
import DashBoardReports from '../../components/Reports/ReportsStats'
const Index = ({ setHeading }) => {
  const [renderComponent, SetrendeComponent] = useState('users')
  useEffect(() => {
    setHeading('Reports')
  }, [])
  return (
    <div>
      <DashBoardReports setRenderComponent={SetrendeComponent} renderComponent={renderComponent} />
      <Reports renderComponent={renderComponent} />
    </div>
  )
}

export default Index
